import PayOutAccountServices from "@/services/PayOutAccountServices";
import PayOutAccountRequest from "@/model/requests/PayOutAccountRequest";
import ProfessionalResponse from "@/model/responses/ProfessionalResponse";
import CustomerResponse from "@/model/responses/CustomerResponse";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";
import ProfessionalServices from "@/services/ProfessionalServices";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
const payOutAccountService = new PayOutAccountServices();
export const namespaced = true;

export const state = {
  payOutAccount: {},
  countries: []
};

export const getters = {};

export const mutations = {
  updatePayOutAccount: (state, payload) => {
    state.payOutAccount = payload;
  },
  setCountries: (state, payload) => {
    state.countries = payload;
  }
};

export const actions = {
  updatePayOutAccount({ commit }, payload = PayOutAccountRequest.update) {
    let successAction = () => {
      let customerId = StoreUtils.rootGetters("auth/getUserInfo").customerId;
      StoreUtils.dispatch("customer/readByCustomerId", { customerId });
    };
    return payOutAccountService.updatePayOutAccount(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readPayOutAccountById({ commit }, payload = PayOutAccountRequest.readBy) {
    let successAction = responseData => {
      commit("updatePayOutAccount", responseData.data);
    };
    return payOutAccountService.readByPayOutAccount(
      payload,
      successAction,
      LoaderUtils.types.NONE
    );
  },
  // getCountries({commit}, payload = PayOutAccountRequest.getCountries){
  //   let successAction = responseData => {
  //     commit("setCountries", responseData.data);
  //   };
  //   return payOutAccountService.getCountries(
  //       payload,
  //       successAction,
  //       LoaderUtils.types.NONE
  //   );
  // },
  createStripePayoutAccount(
    { commit },
    payload = PayOutAccountRequest.createStripePayoutAccount
  ) {
    let successAction = responseData => {
      window.location.href = responseData.location;
      // console.log(responseData.location);
    };
    return payOutAccountService.createStripeAccount(
      payload,
      successAction,
      LoaderUtils.types.BLOCKING
    );
  }
};
